var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AttachmentDownload", {
    attrs: { attachment: _vm.rowData.file, title: "Download" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }